import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Plus, Calendar, Receipt, Upload, X, Zap } from 'lucide-react';
import { cn } from '../lib/utils';

export default function QuickActions() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const actions = [
    { icon: Calendar, label: 'Réservation', path: '/reservations', color: 'bg-pink-500' },
    { icon: Receipt, label: 'Dépense', path: '/depenses', color: 'bg-blue-500' },
    { icon: Upload, label: 'Importer', path: '/reservations', color: 'bg-green-500' },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50 md:hidden">
      {/* Action buttons */}
      <div className={cn(
        "absolute bottom-16 right-0 flex flex-col gap-3 transition-all duration-300",
        isOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      )}>
        {actions.map((action, index) => (
          <button
            key={action.label}
            onClick={() => {
              navigate(action.path);
              setIsOpen(false);
            }}
            className={cn(
              "flex items-center gap-3 px-4 py-2 rounded-full shadow-lg text-white text-sm font-medium",
              "transition-all duration-300 hover:scale-105",
              action.color
            )}
            style={{ transitionDelay: `${index * 50}ms` }}
          >
            <action.icon className="h-4 w-4" />
            {action.label}
          </button>
        ))}
      </div>

      {/* Main FAB */}
      <Button
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "h-14 w-14 rounded-full shadow-lg transition-all duration-300",
          "bg-primary hover:bg-primary/90 text-primary-foreground",
          isOpen && "rotate-45 bg-red-500 hover:bg-red-600"
        )}
      >
        {isOpen ? <X className="h-6 w-6" /> : <Zap className="h-6 w-6" />}
      </Button>
    </div>
  );
}
